import React from 'react';
import Restaurant from './components/Basics/Restaurant';

const App = () => {
  return <Restaurant />;
};

export default App;

